module.exports = __webpack_public_path__ + "static/media/hm.45e61c98.svg";